import React from "react";
import { NavLink } from "react-router-dom";
import PageLayout from "../Components/pageLayout/PageLayout";
import PageSubHeader from "../Components/pageSubHeader/PageSubHeader";
import { usePageSeo } from "../Core/utils";

const NotFound = () => {
  usePageSeo({});

  return (
    <PageLayout className="not-found-container" title="Oops!">
      <PageSubHeader
        title="Cette page n'existe pas!"
        intro={
          <NavLink className="link" to="/">
            Retourner à l&apos;accueil
          </NavLink>
        }
      />
    </PageLayout>
  );
};

export default NotFound;
